import type { Copy } from "../types";

export const th: Copy = {
    seo: {
      title: "เครื่องคำนวณอายุรถ | ตรวจอายุรถตามปีและเดือน",
      description:
        "ตรวจอายุรถที่แม่นยำจากปีที่ผลิตและเดือนที่เลือกได้ ดูปี เดือน วัน จำนวนวันทั้งหมด และจุดสำคัญต่างๆ ในเครื่องมือเดียวที่เรียบง่าย",
      keywords: [
        "เครื่องคำนวณอายุรถ",
        "เครื่องคำนวณอายุยานพาหนะ",
        "ตรวจปีผลิตรถ",
        "ตรวจเดือนผลิตรถ",
        "รถของฉันอายุกี่ปี",
        "ตรวจอายุรถตามปี",
        "ตรวจอายุรถ",
        "เครื่องคำนวณอายุ RC",
        "ตรวจอายุรถตามเดือน",
        "เครื่องคำนวณวันที่รถ",
        "mParivahan ทางเลือก",
        "Parivahan ทางเลือก",
        "เครื่องคำนวณอายุรถ RTO",
        "ตรวจอายุทะเบียนรถ",
        "อายุทะเบียนยานพาหนะ",
      ],
      faq: [
        {
          question: "เครื่องมือนี้ทำอะไร?",
          answer:
            "เครื่องมือนี้คำนวณอายุรถอย่างแม่นยำจากปีผลิตที่เลือกและเดือนที่เลือกได้ จากนั้นจะแสดงปี เดือน วัน และข้อมูลจุดสำคัญ",
        },
        {
          question: "ทำไมมีเดือนให้เลือกแบบไม่บังคับ?",
          answer:
            "การเพิ่มเดือนช่วยให้คำนวณอายุได้แม่นยำขึ้น หากไม่เลือกเดือน ระบบจะใช้เดือนมกราคมของปีที่เลือก",
        },
        {
          question: "เลือกปีหรือเดือนในอนาคตได้ไหม?",
          answer:
            "ไม่ได้ ปีในอนาคตถูกปิดกั้น และเดือนในอนาคตจะถูกปิดใช้งานเมื่อปีที่เลือกเป็นปีปัจจุบัน",
        },
      ],
    },
    headerTagline: "เครื่องมือรถ",
    headerTitle: "เครื่องคำนวณอายุรถ",
    reset: "รีเซ็ต",
    switchToLight: "สลับเป็นโหมดสว่าง",
    switchToDark: "สลับเป็นโหมดมืด",
    languageLabel: "ภาษา",
    languageEnglish: "ภาษาอังกฤษ",
    languageHindi: "ภาษาฮินดี",
    heroEyebrow: "อายุรถที่ชัดเจน",
    heroTitle: "เครื่องมือวันที่ที่เรียบง่ายสำหรับดูอายุรถ",
    heroDescription: "เลือกปีที่ผลิต เพิ่มเดือนเฉพาะเมื่ออยากได้ผลลัพธ์ที่แม่นยำขึ้น",
    yearSelectLabel: "ปีที่ผลิต",
    monthSelectLabel: "เดือนที่ผลิต",
    includeMonthLabel: "รวมเดือนที่เฉพาะเจาะจงเพื่อความแม่นยำมากขึ้น",
    includeMonthNote: "หากไม่รวมเดือน ระบบจะใช้เดือนมกราคมในการคำนวณ",
    yearOnlyBadge: "เฉพาะปี",
    yearMonthBadge: "ปี + เดือน",
    yearPlaceholder: "เลือกปี",
    monthPlaceholder: "เลือกเดือน",
    inputTitle: "ปีที่ผลิต",
    inputLabel: "ปีที่ผลิต",
    blockedDateNote: "ไม่อนุญาตให้เลือกปีในอนาคต",
    result: "ผลลัพธ์",
    vehicleAgeLead: "รถของคุณเป็น",
    asOfToday: "ณ วันนี้",
    years: "ปี",
    months: "เดือน",
    days: "วัน",
    totalDays: (count) => `${count.toLocaleString("en-IN")} วันทั้งหมด`,
    ageLabels: { almostNew: "เกือบใหม่", modern: "ทันสมัย", mature: "เริ่มเก่า", classic: "คลาสสิก" },
    estimatedValue: {
      high: "ศักยภาพการขายต่อสูง",
      healthy: "รักษามูลค่าได้ดี",
      moderate: "เสื่อมค่าปานกลาง",
      collector: "ความสนใจจากนักสะสมอาจเพิ่มขึ้น",
    },
    maintenanceTitle: "การบำรุงรักษา",
    maintenance: {
      routine: "การเข้ารับบริการตามปกติและการดูแลแบบ OEM",
      watch: "ระวังเบรก ของเหลว และยาง",
      plan: "วางแผนชิ้นส่วนที่สึกหรอและการตรวจเช็ก",
      specialized: "การบำรุงรักษาเฉพาะทางมีความสำคัญมากขึ้น",
    },
    registrationTitle: "การจดทะเบียน",
    registration: {
      collector: "บางพื้นที่อาจได้รับการดูแลแบบรถสะสม",
      classic: "บางพื้นที่อาจใช้การจดทะเบียนแบบรถคลาสสิก",
      standard: "คาดว่าจะมีการต่ออายุและการตรวจตามพื้นที่ตามปกติ",
      regular: "โดยทั่วไปใช้การจดทะเบียนปกติ",
    },
    upcomingMilestoneTitle: "จุดสำคัญถัดไป",
    milestoneTimelineTitle: "ไทม์ไลน์จุดสำคัญ",
    milestoneRemaining: ({ label, days }) => `${label} ในอีก ${days.toLocaleString("th-TH")} วัน`,
    reached: "ถึงแล้ว",
    upcoming: "ถัดไป",
    allMilestonesReachedTitle: "ถึงจุดสำคัญทั้งหมดที่แสดงแล้ว",
    allMilestonesReachedBody: "รถคันนี้ผ่านช่วงจุดสำคัญที่แสดงในแอปแล้ว",
    copySummary: "คัดลอกสรุป",
    shareResult: "แชร์ผลลัพธ์",
    resetMessage: "รีเซ็ตเครื่องคำนวณแล้ว",
    summaryCopied: "คัดลอกสรุปไปยังคลิปบอร์ดแล้ว",
    clipboardFailed: "เข้าถึงคลิปบอร์ดไม่สำเร็จ",
    emptyTitle: "เลือกปีที่ผลิตเพื่อดูรายละเอียดทั้งหมด",
    emptyDescription:
      "เมื่อเลือกปีแล้ว คุณจะเห็นอายุที่แม่นยำ จำนวนวันทั้งหมด หมายเหตุการบำรุงรักษา สถานะคลาสสิก และเวลาของจุดสำคัญ",
    shareTitle: "เครื่องคำนวณอายุรถ",
    summary: ({ label, years, months, days, asOf }) =>
      `รถของฉันผลิตใน ${label} และมีอายุ ${years} ปี ${months} เดือน ${days} วัน ณ ${asOf}`,
    milestones: {
      1: { label: "ปีแรก", note: "มีประโยชน์สำหรับการรับประกันและการวางแผนบริการ" },
      3: { label: "สามปี", note: "เป็นช่วงที่พบบ่อยสำหรับการขายต่อและการเปลี่ยนมูลค่า" },
      5: { label: "ห้าปี", note: "เหมาะสำหรับทบทวนงบประมาณการบำรุงรักษา" },
      10: { label: "สิบปี", note: "ชิ้นส่วนที่เริ่มเก่าควรได้รับความสนใจมากขึ้น" },
      15: { label: "สิบห้าปี", note: "หลายพื้นที่เริ่มดูแลในแบบรถคลาสสิก" },
      25: { label: "ยี่สิบห้าปี", note: "อาจน่าสนใจสำหรับนักสะสมและการนำเข้าในบางตลาด" },
    },
  };
